import React, { useRef, useState, useEffect } from 'react'
import { useExclusiveMenu } from '../../hooks/useExclusiveMenu'
import FormControl from '@mui/material/FormControl'
import { SelectChangeEvent } from '@mui/material/Select'
import TagPriority from './TagPriority'
import { useTranslation } from 'react-i18next'
import Select, { SingleValue } from 'react-select'
import { incyiaSelectStyles } from '../../utils/incyiaSelectStyles'
import '../../i18n'

interface SelectCriticalityProps {
  value: number
  onChange: (event: SelectChangeEvent<number>, child?: React.ReactNode) => void
  portalTargetSelector?: string
  hideLabel?: boolean
}

const SelectCriticality: React.FC<SelectCriticalityProps> = ({
  value,
  onChange,
  portalTargetSelector = '.page-content',
  hideLabel = true,
}) => {
  const menu = useExclusiveMenu()
  const { t } = useTranslation()
  const containerRef = useRef<HTMLDivElement>(null)


  const selectOptions = [1, 2, 3, 4].map((priority) => ({
    value: priority,
    label: t(`priority.${priority}`, { defaultValue: String(priority) }),
  }))

  const selectedOption =
    selectOptions.find((opt) => opt.value === value) || null

  const handleSelectChange = (
    selected: SingleValue<{ value: number; label: string }>
  ) => {
    const event = {
      target: { value: selected ? selected.value : 0 },
    } as SelectChangeEvent<number>
    onChange(event)
  }

  return (
    <div ref={containerRef} style={{ width: '100%', position: 'relative' }}>
      {!hideLabel ? (
        <label
          style={{
            position: 'absolute',
            top: '-8px',
            left: '12px',
            fontSize: '12px',
            color: 'rgba(0, 0, 0, 0.6)',
            backgroundColor: 'white',
            padding: '0 4px',
            zIndex: 60,
          }}
        >
          {t('Criticality')}
        </label>
      ) : null}
      <FormControl fullWidth style={{ width: '100%' }}>
        <Select
          value={selectedOption}
          onChange={handleSelectChange}
          options={selectOptions}
          formatOptionLabel={(option) => (
            <TagPriority priority={option.value} />
          )}
          placeholder={t('Criticality')}
          styles={incyiaSelectStyles}
          {...menu}
          isMulti={false}
        />
      </FormControl>
    </div>
  )
}

export default SelectCriticality
